module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c4"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Works by Herman Wouk")]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("Aurora Dawn")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("City Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("The Caine Mutiny")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("Marjorie Morningstar")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("Youngblood Hawke")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("Don't Stop the Carnival")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("The Winds of War")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("War and Remembrance")])]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("Inside, Outside")])]), _vm._v(" "), _c('p', {
    staticClass: "c5"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("This Is My God")]), _vm._v(" (nonfiction)")]), _vm._v(" "), _c('p', {
    staticClass: "c191a"
  }, [_c('em', {
    staticClass: "calibre7"
  }, [_vm._v("The Caine Mutiny Court-Martial")]), _vm._v(" (play)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471a29da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0003.vue
// module id = 69
// module chunks = 0